module.exports = __webpack_public_path__ + "static/media/icon-crosshair.20d0ed98.svg";